var React = require('react');

function Megaphone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5 2.8125C22.5 2.35762 22.2645 1.93517 21.8775 1.69602C21.4906 1.45688 21.0074 1.43514 20.6005 1.63857L10.3777 6.75H5.4375C3.26288 6.75 1.5 8.51288 1.5 10.6875C1.5 12.8621 3.26288 14.625 5.4375 14.625H5.80401L8.12986 21.6025C8.30851 22.1385 8.81007 22.5 9.37501 22.5H10.6875C11.4124 22.5 12 21.9124 12 21.1875V15.4362L20.6005 19.7364C21.0074 19.9399 21.4906 19.9181 21.8775 19.679C22.2645 19.4398 22.5 19.0174 22.5 18.5625V2.8125Z","fill":"#374151"}));
}

Megaphone.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Megaphone;

Megaphone.default = Megaphone;
